import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_DOCENTES,
  ALL_BLOQUES_HORAS_DOCENTES,
  ALL_DOCENTES,
  LOADING_ALL_DOCENTES,
} from './DocentesReducer';
import {
  allBloquesDocentesService,
  allDocentesService,
  asignarBloquesDocentesService,
  asignarDiasClasesDocentesService,
  asignarMateriasDocentesService,
  asignarSeccionesDocentesService,
  deleteBloquesDocentesService,
  deleteMateriasDocentesService,
  deleteSeccionesDocentesService,
  oneDocentesService,
} from './DocentesService';

export const allDocentesAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_DOCENTES, payload: true });
    const res = await allDocentesService(params);
    dispatch({ type: ALL_DOCENTES, payload: res.data });
    dispatch({ type: LOADING_ALL_DOCENTES, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_DOCENTES, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const setActivoDocentesAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_DOCENTES, payload: data });
};

export const oneDocentesAction = async (dispatch, id) => {
  try {
    dispatch({ type: LOADING_ALL_DOCENTES, payload: true });
    const res = await oneDocentesService(id);
    dispatch({ type: LOADING_ALL_DOCENTES, payload: false });
    await setActivoDocentesAction(dispatch, res.data.data);
    return res.data.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_DOCENTES, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const asignarMateriasDocentesAction = async (
  { dispatch, notify },
  data,
) => {
  try {
    const res = await asignarMateriasDocentesService(data);
    notify(res.data.message);
    await oneDocentesAction(dispatch, data.idDocente);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const deleteMateriasDocentesAction = async (
  { dispatch, notify },
  idDocente,
  id,
) => {
  try {
    const res = await deleteMateriasDocentesService(id);
    notify(res.data.message);
    await oneDocentesAction(dispatch, idDocente);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const asignarSeccionesDocentesAction = async (
  { dispatch, notify },
  data,
) => {
  try {
    const res = await asignarSeccionesDocentesService(data);
    notify(res.data.message);
    await oneDocentesAction(dispatch, data.idDocente);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const deleteSeccionesDocentesAction = async (
  { dispatch, notify },
  idDocente,
  id,
) => {
  try {
    const res = await deleteSeccionesDocentesService(id);
    await oneDocentesAction(dispatch, idDocente);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const asignarDiasClasesDocentesAction = async (
  { dispatch, notify },
  data,
) => {
  try {
    const res = await asignarDiasClasesDocentesService(data);
    notify(res.data.message);
    await oneDocentesAction(dispatch, data.idDocente);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const allBloquesDocenteAction = async (dispatch, params) => {
  try {
    const res = await allBloquesDocentesService(params);
    dispatch({ type: ALL_BLOQUES_HORAS_DOCENTES, payload: res.data });
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const asignarBloquesDocentesAction = async (
  { dispatch, notify },
  data,
) => {
  try {
    const res = await asignarBloquesDocentesService(data);
    notify(res.data.message);
    await allBloquesDocenteAction(dispatch, {
      idDocente: data.idDocente,
    });
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const deleteBloquesDocentesAction = async (
  { dispatch, notify },
  idDocente,
  id,
) => {
  try {
    const res = await deleteBloquesDocentesService(id);
    notify(res.data.message);
    await allBloquesDocenteAction(dispatch, { idDocente });
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
